import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import { authHelper } from '@/services/AuthHelpers';
import { DecodedToken } from '@/types/jwt';
import { errorInterceptor } from './ErrorInterceptor';
import { responseInterceptor } from './ResponseInterceptor';

export const api = axios.create({
  baseURL: `${import.meta.env.VITE_PUBLIC_API_URL}`,
});

api.interceptors.request.use((config) => {
  const token = authHelper.getAuth();

  if (token) {
    const decodedToken = jwtDecode<DecodedToken>(token);

    if (decodedToken.exp && decodedToken.exp * 1000 < Date.now()) {
      authHelper.removeAuth();
      window.location.href = '/login';
      return Promise.reject(new Error('Token expired'));
    }

    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

api.interceptors.response.use(
  (response) => responseInterceptor(response),
  (error) => errorInterceptor(error)
);
